import { UserSettingsType } from '~/types-and-enums/settingsTypes';

export const DD_MM_YYYY = 'dd.MM.yyyy';
export const YYYY_MM_DD = 'yyyy-MM-dd';
export const HH_MM = 'HH:mm';
export const DB_DATE_FORMAT = 'yyyy-MM-dd';
export const DN_DD_MM_YYYY_HH_MM = 'dd.MM.yyyy HH:mm';
export const DD_MM = 'dd.MM';
export const NOT_APPLICABLE = 'N/A';

export const API_HOST: string = `http://${process.env.BUYER_APP_SERVICE_URL}`;
export const MOCK_HOST = process.env.MOCK_HOST;

export const EMAIL_SERVICE = 'service@andercore.com';
export const EMAIL_SALES = 'sales@andercore.com';
export const EMAIL_LOGISTICS = 'logistics@andercore.com';
export const CONTACT_NUMBER = '+49 30 30809217';

export const DEFAULT_PAGE_SIZE = 20;
export const TILDE = '~';

export const BULLET_POINT = ' • ';

export const USER_SETTINGS_EMPTY: UserSettingsType = {
  company_information: {
    name: '',
    address: {
      street: '',
      postal_code: '',
      city: null,
      country: null,
    },
    credit_limit: {
      value: 0,
      currency: '',
    },
    store_access: false,
  },
  user_data: {
    first_name: '',
    last_name: '',
    email: '',
  },
  account_manager: {
    name: '',
    telephone: null,
    email: '',
    first_name: '',
    last_name: '',
    phone: '',
    profile_photo_url: '',
  },
  preferences: {
    locale: null,
    notification: {
      delivery_updates: {
        email: {
          enabled: false,
          recipient: '',
        },
        sms: {
          enabled: false,
          recipient: null,
        },
        whatsapp: {
          enabled: false,
          recipient: null,
        },
      },
      newsletter: {
        email: {
          enabled: false,
          recipient: null,
        },
      },
      storeLaunch: false,
    },
  },
  delivery_address: {
    street: '',
    postal_code: '',
    city: '',
    country: '',
    email: '',
    delivery_contact_name: '',
    delivery_contact_email: '',
    delivery_contact_phone: '',
    warehouse_opening_hours: '',
    maximum_delivery_capacity: '',
    accept_container_delivery: false,
    forklift_available: false,
    delivery_additional_info: '',
    company_name: '',
    is_address_validated: false,
  },
  delivery_contact: {
    name: '',
    phone: '',
    email: '',
  },
  delivery_info: {
    delivery_times: '',
    maximum_delivery_capacity: '',
    accept_container_delivery: '',
    forklift_available: '',
    delivery_additional_info: '',
  },
  billing_address: {
    street: '',
    postal_code: '',
    city: '',
    country: '',
    email: '',
  },
};

export const COUNTRY_PHONE_LIST = [
  {
    id: 1,
    value: '+49',
    label: 'Germany',
    flagUrl: 'DE',
    code: '+49',
  },
  {
    id: 2,
    value: '+33',
    label: 'France',
    flagUrl: 'FR',
    code: '+33',
  },
  {
    id: 3,
    value: '+34',
    label: 'Spain',
    flagUrl: 'ES',
    code: '+34',
  },
  {
    id: 4,
    value: '+44',
    label: 'United Kingdom',
    flagUrl: 'EN',
    code: '+44',
  },
  {
    id: 5,
    value: '+32',
    label: 'Belgium',
    flagUrl: 'BE',
    code: '+32',
  },
  {
    id: 6,
    value: '+31',
    label: 'Netherlands',
    flagUrl: 'NL',
    code: '+31',
  },
  {
    id: 7,
    value: '+351',
    label: 'Portugal',
    flagUrl: 'PT',
    code: '+351',
  },
  {
    id: 8,
    value: '+43',
    label: 'Austria',
    flagUrl: 'AT',
    code: '+43',
  },
  {
    id: 9,
    value: '+48',
    label: 'Austria',
    flagUrl: 'PL',
    code: '+48',
  },
  {
    id: 10,
    value: '+41',
    label: 'Switzerland',
    flagUrl: 'CH',
    code: '+41',
  },
  {
    id: 11,
    value: '+420',
    label: 'Czech republic',
    flagUrl: 'CZ',
    code: '+420',
  },
];

export const COUNTRY_NAMES_LIST = [
  {
    id: 1,
    value: 'Germany',
    label: 'Germany',
  },
  {
    id: 2,
    value: 'France',
    label: 'France',
  },
  {
    id: 3,
    value: 'Spain',
    label: 'Spain',
  },
  {
    id: 4,
    value: 'United Kingdom',
    label: 'United Kingdom',
  },
  {
    id: 5,
    value: 'Belgium',
    label: 'Belgium',
  },
  {
    id: 6,
    value: 'Netherlands',
    label: 'Netherlands',
  },
  {
    id: 7,
    value: 'Portugal',
    label: 'Portugal',
  },
  {
    id: 8,
    value: 'Austria',
    label: 'Austria',
  },
  {
    id: 9,
    value: 'Austria',
    label: 'Austria',
  },
  {
    id: 10,
    value: 'Switzerland',
    label: 'Switzerland',
  },
  {
    id: 11,
    value: 'Czech republic',
    label: 'Czech republic',
  },
];

export const SEARCH_PARAM_SET_PASSWORD_MODAL = 'set-password-modal';
export const SEARCH_PARAM_UPDATE_PASSWORD_MODAL = 'update-password-modal';
export const SEARCH_PARAM_RESET_PASSWORD_MODAL = 'reset-password-modal';
export const SEARCH_PARAM_RESOLVE_CLAIM_MODAL = 'resolve-claim-modal';
export const SETTINGS_PREFERENCES_UPDATE_MODAL =
  'user-preferences-update-modal';

// List of ISO 3166-1 alpha-2 country codes
export const COUNTRY_CODES = [
  'AF',
  'AL',
  'DZ',
  'DE',
  'AU',
  'AT',
  'BE',
  'BR',
  'CA',
  'CN',
  'FR',
  'GB',
  'IN',
  'IT',
  'JP',
  'MX',
  'NL',
  'NZ',
  'RU',
  'ES',
  'US',
  'ZA',
  // Add more country codes as necessary
];

export const EMPTY_PRICE_PLACEHOLDER = '-,-- €';

export const LOCALES = [
  { locale: 'en' },
  { locale: 'de' },
  { locale: 'fr' },
  { locale: 'it' },
  { locale: 'es' },
];

export const CATEGORIES = [
  { category: 'batteries' },
  { category: 'modules' },
  { category: 'inverters' },
  { category: 'cables' },
];

export const sarahBlancImageUrl = '/images/sarahBlanc.jpeg';
export const ELSACORDONNIER_EMAIL = 'elsa.cordonnier@andercore.com';
export const ELSA = 'Elsa';
export const CORDONNIER = 'Cordonnier';
export const SARAH = 'Sarah';
export const BLANC = 'Blanc';
export const SARAHBLANC_EMAIL = 'sarah.blanc@andercore.com';
